import {useState} from 'react';
import {IconButton, Tooltip} from '@mui/material';
import {CheckCircle, ContentCopy} from '@mui/icons-material';

export default function CopyButton({ text, size = 'small' }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset nach 2 Sekunden
    } catch (error) {
      console.error('Fehler beim Kopieren:', error);
    }
  };

  return (
    <Tooltip 
      title={copied ? "Code wurde kopiert" : "Code kopieren"}
      placement="top"
      classes={{
        popper: 'tooltip-custom'
      }}
      PopperProps={{
        disablePortal: true
      }}
    >
      <IconButton
        onClick={handleCopy}
        size={size}
        className={`copy-button ${copied ? 'copied' : ''}`}
      >
        {copied ? <CheckCircle fontSize={size} /> : <ContentCopy fontSize={size} />}
      </IconButton>
    </Tooltip>
  );
} 